var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1896",
    "data-name": "Group 1896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_477",
    "data-name": "Path 477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.58,76.92A3,3,0,0,1,6.3,72L38.58,34a3,3,0,0,1,4.57,0L54.55,47.4,88.15,7.88a3,3,0,0,1,4.57,3.89L56.84,54a3,3,0,0,1-4.57,0L40.87,40.57l-30,35.29A3,3,0,0,1,8.58,76.92Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_478",
    "data-name": "Path 478"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.44,36.4a3,3,0,0,1-3-3V12.82H66.86a3,3,0,0,1,0-6H90.44a3,3,0,0,1,3,3V33.4A3,3,0,0,1,90.44,36.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_479",
    "data-name": "Path 479"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.44,93H8.58a3,3,0,0,1-3-3V9.82a3,3,0,0,1,3-3H31.64a3,3,0,0,1,0,6H11.58V87H87.44V73.5a3,3,0,0,1,6,0V90A3,3,0,0,1,90.44,93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/Progress.9bfdd22f60e6383b922c152a4526f2cc.svg";
export { ForwardRef as ReactComponent };